import { render } from "./cmbarchart.vue?vue&type=template&id=0b564890&scoped=true"
import script from "./cmbarchart.vue?vue&type=script&lang=js"
export * from "./cmbarchart.vue?vue&type=script&lang=js"

import "./cmbarchart.vue?vue&type=style&index=0&id=0b564890&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b564890"]])

export default __exports__